export const FETCH_ADS_START = 'FETCH_ADS_START';
export const FETCH_ADS_SUCCESS = 'FETCH_ADS_SUCCESS';
export const FETCH_ADS_FAILED = 'FETCH_ADS_FAILED';
export const FETCH_ADS_COMPLETED = 'FETCH_ADS_COMPLETED';

export const CLICKOUT_START = 'CLICKOUT_START';
export const CLICKOUT_REQUEST = 'CLICKOUT_REQUEST';
export const CLICKOUT_SUCCESS = 'CLICKOUT_SUCCESS';
export const CLICKOUT_FAILED = 'CLICKOUT_FAILED';

export const FETCH_AUTOCOMPLETE_REQUEST = 'FETCH_AUTOCOMPLETE_REQUEST';
export const FETCH_AUTOCOMPLETE_START = 'FETCH_AUTOCOMPLETE_START';
export const FETCH_AUTOCOMPLETE_SUCCESS = 'FETCH_AUTOCOMPLETE_SUCCESS';
export const FETCH_AUTOCOMPLETE_FAILED = 'FETCH_AUTOCOMPLETE_FAILED';

export const SET_SEARCH_PARAMS = 'SET_SEARCH_PARAMS';

export const SET_SHOULD_RESET_WHERE = 'SET_SHOULD_RESET_WHERE';
export const RESET_SHOULD_RESET_WHERE = 'UNSET_SHOULD_RESET_WHERE';

export const RESET_SEARCH_PARAMS_TO_SERP_SEARCH = 'RESET_SEARCH_PARAMS_TO_SERP_SEARCH';

export const REMOVE_GEO_ID = 'REMOVE_GEO_ID';

export const ACTIVATE_USER_SEARCH_INTERACTION = 'ACTIVATE_USER_SEARCH_INTERACTION';

export const FETCH_ADS_VISIT_COUNTER = 'FETCH_ADS_VISIT_COUNTER';
export const SET_OR_INCREMENT_AD_VISIT_COUNTER = 'SET_OR_INCREMENT_AD_VISIT_COUNTER';
export const SET_ADS_VISIT_COUNTER = 'SET_ADS_VISIT_COUNTER';

export const REDIRECT_TO_AD_SOURCE = 'REDIRECT_TO_AD_SOURCE';
export const REDIRECT_TO_AD_PAGE = 'REDIRECT_TO_AD_PAGE';

export const SHOW_RELATED_ADS_POPUP = 'SHOW_RELATED_ADS_POPUP';
export const HIDE_RELATED_ADS_POPUP = 'HIDE_RELATED_ADS_POPUP';

export const SET_SEARCH_PARAMS_PAGE = 'SET_SEARCH_PARAMS_PAGE';

export const TRACKING_RELATED_ADS_MODAL = 'TRACKING_RELATED_ADS_MODAL';

export const LOCAL_FORAGE_KEYS = {
  adsVisitCounter: 'adsVisitCounter',
};

export const INITIALIZE_TYPE_ID = 'INITIALIZE_TYPE_ID';

export const DEFAULT_INITIAL_TYPE_ID = null;
export const HOMES_INITIAL_TYPE_ID = 1;
export const PRODUCTS_INITIAL_TYPE_ID = 0;

export const ENABLE_RETRACK_AD_IMPRESSIONS = 'ENABLE_RETRACK_AD_IMPRESSIONS';

export const SECTIONS_WITHOUT_MODAL = [190, 149, 157];

export const REDIRECT_URL_PARAMETERS = {
  userId: 'user_id',
  section: 'section',
};

// JOBS

export const SUGGESTER = {
  noSuggestion: 0,
  cityOrRegion: 1,
  touristicZone: 2,
};



// WEBPACK FOOTER //
// ./app/Serp/constants.js